// src/environments/environment.ts
export const environment = {
  production: false,
  // url: 'https://api.loadboardnetwork.com/api' //Prod
  url: 'https://api-staging1.loadboardnetwork.com/api', // DEV
  socketUrl: "https://api-staging1.loadboardnetwork.com",
  // analyticsAPI: 'https://analytics.loadboardnetwork.com/api/v1', // PROD
  analyticsAPI: 'https://analytics-staging1.loadboardnetwork.com/api/v1', // DEV
  queue: "https://queue-staging1.loadboardnetwork.com",
  website: 'https://web-staging1.loadboardnetwork.com',
  // Paid signup via Zoho checkout (/signup). Off = "Free Sign Up" keeps using /register.
  zohoSignupEnabled: true,
  // Demo signup (Zoho customer only, no card). Requires API ZOHO_DEMO_SIGNUP_ENABLED=true.
  zohoDemoSignupEnabled: true,
  // Zoho Billing customer portal (customers sign in with their billing email). Empty = links hidden.
  zohoPortalUrl: 'https://billing.zohosecure.com/portal/lbnbillingtesttest',
  // Zoho Billing admin app for the org (superadmin "Open in Zoho" links). Empty = links hidden.
  zohoBillingAppUrl: 'https://billing.zoho.com/app/939824391'
};